class AnnouncementBarSlider extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
    this.dots = Array.from(this.querySelectorAll('[data-announcement-dot]'));
    this.currentIndex = 0;
    this.autoPlayInterval = null;
    this.autoPlayDelay = 5000;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', this.handleDotClick.bind(this));
    });

    this.startAutoPlay();
    this.addEventListener('mouseenter', this.pauseAutoPlay.bind(this));
    this.addEventListener('mouseleave', this.startAutoPlay.bind(this));

    // 减少动效偏好：不自动轮播
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.pauseAutoPlay();
    }
  }

  handleDotClick(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10);
    this.goToSlide(index);
    this.restartAutoPlay();
  }

  goToSlide(index) {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
    this.currentIndex = index;
  }

  nextSlide() {
    const next = (this.currentIndex + 1) % this.slides.length;
    this.goToSlide(next);
  }

  startAutoPlay() {
    if (this.slides.length <= 1) return;
    this.pauseAutoPlay();
    this.autoPlayInterval = setInterval(() => this.nextSlide(), this.autoPlayDelay);
  }

  pauseAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }

  restartAutoPlay() {
    this.pauseAutoPlay();
    this.startAutoPlay();
  }
}

customElements.define('announcement-bar-slider', AnnouncementBarSlider);
